export interface NetWorthTrendData {
    fundInfo: {
        name: string;
        trend: string;
        openingBalance: number;
        currentBalance: number;
        change: string;
        currency: string;
    };
    trends: {
        daily: {
            labels: string[];
            values: number[];
            displayLabels: string[];
        };
        weekly: {
            labels: string[];
            values: number[];
            displayLabels: string[];
        };
        monthly: {
            labels: string[];
            values: number[];
            displayLabels: string[];
        };
        annually: {
            labels: string[];
            values: number[];
            displayLabels: string[];
        };
    };
}

export const MOCK_NET_WORTH_TREND_DATA: NetWorthTrendData = {
    fundInfo: {
        name: 'Axis ELSS Fund',
        trend: '+1%',
        openingBalance: 58200,
        currentBalance: 5505000.35,
        change: '+6.5%',
        currency: 'INR'
    },
    trends: {
        daily: {
            labels: Array.from({ length: 48 }, (_, i) => `Point ${i}`),
            values: [25, 45, 35, 55, 40, 75, 65, 65, 45, 30, 35, 25, 42, 32, 45, 28, 28, 38, 32, 35, 35, 32, 22, 40, 40, 30, 40, 40, 72, 72, 42, 35, 40, 50, 60, 65, 60, 68, 75, 45, 65, 72, 45, 58, 62, 40, 55, 70],
            displayLabels: ['5 Jun', '15 Jun', '25 Jun', '5 Jul']
        },
        weekly: {
            labels: ['Week 1', 'Week 2', 'Week 3', 'Week 4', 'Week 5'],
            values: [40, 55, 45, 70, 65],
            displayLabels: ['Week 1', 'Week 2', 'Week 3', 'Week 4', 'Week 5']
        },
        monthly: {
            labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
            values: [30, 40, 35, 50, 45, 60],
            displayLabels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun']
        },
        annually: {
            labels: ['2020', '2021', '2022', '2023', '2024'],
            values: [20, 35, 50, 45, 75],
            displayLabels: ['2020', '2021', '2022', '2023', '2024']
        }
    }
};
